import $ from 'jquery';
import autosize from 'autosize';
import { iframeResizer } from 'iframe-resizer';

/**
 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
 *
 * @see https://github.com/jackmoore/autosize
 * @param context
 */
export default function autosizeDirective(context=document.body) {
    const $context = $(context);
    autosize($context.find('textarea[sw-autosize]'));

    $context.find('iframe[sw-autosize]').each(function() {
        iframeResizer({ checkOrigin: false }, this);
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/autosize.js